import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import CityForm from '../containers/CityFormContainer';
import DocumentHead from '../../../../elements/components/DocumentHead';
import Logger from '../../../../../../lib/Logger';

class CityEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `CityEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('city_route_edit')} />
          <CityForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default CityEditScreen;

Logger.log('silly', `CityEditScreen loaded.`);
